// import { push } from 'react-router-redux';
// import gaPush, { gaSetUser } from '../globs/utils/google-analytics';


export default function clearStorage() {
    console.log('clear action ')

  return (dispatch) => {
    dispatch(clearReduxStorage());
  };
}

function clearReduxStorage() {
    return {
      type: 'clearStorage',
      payload: {},
    };
  }
  